const ERROR = 'AdobeStatusError';
const INVALIDATE = 'AdobeStatusInvalidate';
const POLL_FREQUENCY = 300000;
const RECENT_HISTORY_THRESHOLD = 3600000;
const REFRESH = 'AdobeStatusRefresh';

export {ERROR, INVALIDATE, POLL_FREQUENCY, RECENT_HISTORY_THRESHOLD, REFRESH};
